<template>
  <div id="main-content" class="add-pickup-route">
    <el-col :offset="1" :span="22">
      <PageTitle :title="title" :backLink="backLink"></PageTitle>
      <form>
        <el-row>
          <el-col :span="12" style="display: inline">
            <el-col :span="8">
              <span class="required-star">* </span><span class="form-lable">{{ $t('common.pickup_route') }}</span>
            </el-col>
            <el-select v-model="routeSelect.id" collapse-tags @change="changeIndex"
                       style="width: 60%;float: left;margin: 0 !important;" :placeholder="$t('common.please_select')">
              <el-option
                v-for="(route, index) in parentPickupRouteList"
                :key="route.pickup_route_id"
                :label="route.route_name"
                :value="index">
              </el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="display: inline">
            <el-button style="font-size: 20px; width: 30%" @click="goToSettingBus" type="success">{{ $t('common.edit') }}</el-button>
          </el-col>
        </el-row>
        <el-row v-if="currentIndex != null" class="row-section" style="height: 85px; padding-top: 30px">
          <span style="line-height: 40px;margin-left: 20px; font-size: 22px">{{ $t('route.pickup_route_information') }}</span>
        </el-row>
        <el-row v-if="currentIndex != null">
          <div v-for="(place, index) in parentPickupRouteList[currentIndex].place_list" :key="place.id">
            <el-col :span="6" style="display: inline">
              <span class="form-lable">{{ $t('common.bus_stop') }} {{ index + 1 }}:</span>
              <span class="info-span"> {{ place.name }} </span>
            </el-col>
          </div>
        </el-row>
        <el-row style="padding-top: 20px" v-if="currentIndex != null">
          <el-col :span="8" style="display: inline">
            <span class="form-lable">{{ $t('common.bus') }}:</span>
            <span class="info-span"> {{ parentPickupRouteList[currentIndex].bus_info.name }} </span>
          </el-col>
          <el-col :span="8" style="display: inline">
            <span class="form-lable">{{ $t('bus.license_plate') }}:</span>
            <span class="info-span"> {{ parentPickupRouteList[currentIndex].bus_info.license_plate }} </span>
          </el-col>
          <el-col :span="8" style="display: inline">
            <span class="form-lable">{{ $t('common.image') }}:</span>
            <img style="float: left" v-bind:src="parentPickupRouteList[currentIndex].bus_info.image" width="60%"/>
          </el-col>
        </el-row>
      </form>
    </el-col>
  </div>
</template>

<script>
  import PageTitle from '@/components/PageTitle'
  import { basicSort } from '@/utils'

  export default {
    name: "ParentSelectBus",
    components: {
      PageTitle
    },
    data: function () {
      return {
        title: 'route.choose_route',
        backLink: '',
        routeSelect: {
          id: null
        },
        currentIndex: null,
        parentPickupRouteList: []
      }
    },
    methods: {
      changeIndex: function (e) {
        this.currentIndex = e
      },
      goToSettingBus: function () {
        this.$router.push({
          path: '/bus/setting-seat',
          query: {bid: this.parentPickupRouteList[this.currentIndex].bus_info.id}
        });
      }
    },
    mounted: function () {
      let successCallback = (response) => {
        this.parentPickupRouteList = [].concat(response.data.data.pickup_route_parent_list)
        this.parentPickupRouteList.sort((before, after) => basicSort(before, after, 'route_name'))
      }

      let payload = {
        successCallback
      }
      this.$store.dispatch('pickuproute/getParentPickupRouteList', payload)

    }
  }
</script>

<style lang="scss">

</style>